import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import moment from 'moment'
import Title from '../general/title'
import getData from 'helpers/submitData'
import { loadingStatus } from 'actions'
import helpers from 'helpers/helpers'
import FullTable from "components/FullTable"

class RejectionLog extends Component {

	constructor(props) {
		super(props)
		this.state = {
			rows: [],
			sorted: [],
			filtered: [],
		}
	}

	componentDidMount() {
		this.props.loadingStatus(false)
		getData("getRejections", {dates: this.props.currentDates, properties: this.props.activeProperties}).then((resp) => {
			this.setState({rows:resp.data})
		}).catch(e => {
			console.log(e)
		})
	}

	componentDidUpdate(prevProps) {
		if(prevProps !== this.props) {
			getData("getRejections", { dates: this.props.currentDates, properties: this.props.activeProperties })
				.then((resp) => {
					this.setState({ rows: resp.data })
					this.props.loadingStatus(false)
				})
				.catch((e) => {
					console.log(e)
				})
		}
	}

	countActions = (id) => {
		var count = 0
		this.props.payload.activity.forEach((r) => {
			if(id == r.user) {
				count++
			}
		})

		return count
	}

	buildTable = () => {
		let ret = []

		_.forEach(this.state.rows, v => {
			ret.push({
				buyer: `${v.primary_first} ${v.primary_last}`,
				address: v.address,
				builder: v.builderName,
				date: v.addedDate,
				type: v.type,
				submitted_by: v.to,
				action: v.excerpt,
				message: helpers.stripHTML(v.message),
			})
		})

		return ret
	}

	createTable = () => {
		const columns = [
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Submitted By",
				accessor: "submitted_by",
				filterMethod: (f, r) => helpers.tableText(f, r, "submitted_by"),
			},
			{
				Header: "Address",
				accessor: "address",
				filterMethod: (f, r) => helpers.tableText(f, r, "address"),
			},
			{
				Header: "Buyer Name",
				accessor: "buyer",
				filterMethod: (f, r) => helpers.tableText(f, r, "buyer"),
			},
			{
				Header: "Type",
				accessor: "type",
				filterMethod: (f, r) => helpers.tableText(f, r, "type"),
			},
			{
				Header: "Message",
				accessor: "message",
				filterMethod: (f, r) => helpers.tableText(f, r, "message"),
			},
			{
				Header: "Date",
				accessor: "date",
				Cell: (v) => {
					return moment.unix(v.value).format("MM/DD/YY LT")
				},
				filterMethod: (f, r) => helpers.dateFilter(f, r),
			},
		]
		return (
			<div className="content">
				<FullTable
					data={this.buildTable()}
					columns={columns}
					name="rejections"
					title="RejectionLog"
					unset={["edit"]}
					pageSize={20}
				/>
			</div>
		)
	}

	render() {

		return (
			<div className="sales">
				<div className="imageGroup">
					<Title title="Rejection Log" />
					{this.createTable()}
				</div>
			</div>
		)
	}

}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
        compareDates: state.compareDates,
		payload: state.payload,
		activeProperties: state.activeProperties
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({
		loadingStatus
	}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(RejectionLog)